import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Hack4tts_dataset from "./Hack4tts_dataset"; // update path accordingly

function Hack4TTSModalAboutDataset() {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Click Here for more info
      </Button> */}

    <div className="registers-container">
      <a onClick={handleShow} className="regist-btn-outline">
        Read More
      </a> 
    </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Voice Tech for All: About the Datasets</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Hack4tts_dataset />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Hack4TTSModalAboutDataset;
